import { SelectedComicOptionEnum } from '@constant';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStoreComic } from '@types';

const initialState: IStoreComic = {
  selectedOption: SelectedComicOptionEnum.GENRE,
  genreList: [],
  comicNameList: []
};

export const comicSlice = createSlice({
  name: 'comic',
  initialState,
  reducers: {
    initComic: () => {
      return initialState;
    },

    setComic: (state, action: PayloadAction<Partial<IStoreComic>>) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { initComic, setComic } = comicSlice.actions;

export default comicSlice.reducer;
